<script lang="ts">
  import "../../types/react-native-webview.d.ts";
  import { pop } from "svelte-spa-router";
  const { appOnly = false }: { appOnly?: boolean } = $props();

  const isLoadedFromApp =
    new URLSearchParams(window.location.search).get("app") === "true";
  const shouldShow = (appOnly && isLoadedFromApp) || !appOnly;

  function handleGoBack() {
    if (globalThis.ReactNativeWebView !== undefined) {
      globalThis.ReactNativeWebView.postMessage("navigateBack");
    } else {
      pop();
    }
  }
</script>

{#if shouldShow}
  <button
    onclick={handleGoBack}
  >
    <img
      src="./icons/arrow-left-small.svg"
      class="w-[9px] mb-1 mr-1 inline"
      alt="arrow-left"
    />
  </button>
{/if}
